/**
 * Nano Banana 2.1（gemini-2.5-flash-image）manifest
 * 数据来源：画布 configs/nano-banana-2.1.ts
 * 特点：1K/2K/4K 三档清晰度（三档比例选项一致）；参考图上限 14；思考等级（低/中/高）
 * ⚠️ 仅画布展示（feedVisible: false）；feed 流尚未接入该模型（Nano Banana 2 与 2.1 并存）
 */
import type { ImageModelConfig, ImageRatioOption } from '../../types';

/** 三档共用的比例选项（接口 field_map 中 1K/2K/4K 各自列出但内容一致） */
const RATIOS: ImageRatioOption[] = [
  { label: '1:1', value: '1:1' },
  { label: '2:3', value: '2:3' },
  { label: '3:2', value: '3:2' },
  { label: '3:4', value: '3:4' },
  { label: '4:3', value: '4:3' },
  { label: '9:16', value: '9:16' },
  { label: '16:9', value: '16:9' },
  { label: '21:9', value: '21:9' },
];

export const nanoBanana21: ImageModelConfig = {
  id: '01M4Q060HM1K5WGBRV3NY4PK5H',
  displayName: 'Nano Banana 2.1',

  defaults: {
    ratio: '9:16', // 接口各档 select: true 项
    resolution: '2K', // 接口 resolution.default
    thinking_level: 'medium', // 思考等级默认档（中）
  },

  ratioOptions: {
    '1K': RATIOS,
    '2K': RATIOS,
    '4K': RATIOS,
  },

  resolutionOptions: [
    { label: '标清 1K', labelKey: 'canvas.image.config.level1K', value: '1K' },
    { label: '高清 2K', labelKey: 'canvas.image.config.level2K', value: '2K' },
    { label: '超清 4K', labelKey: 'canvas.image.config.level4K', value: '4K' },
  ],
  resolutionLabel: '图片质量', // 接口 field_map.resolution.label
  resolutionLabelKey: 'canvas.image.config.resolutionTitle',

  qualityOptions: [],

  // 支持 @ 参考图（Banana 系列）
  supportAtMention: true,

  toggles: {},

  limits: {
    maxRefImages: 14, // 接口 field_map.ref_images.max
  },

  /** 思考等级按钮组（本模型独占：低/中/高）；feed 与画布均展示 */
  thinkingLevel: {
    label: '思考等级',
    name: 'thinking_level',
    options: [
      { label: '低', value: 'minimal' },
      { label: '中', select: true, value: 'medium' },
      { label: '高', value: 'high' },
    ],
  },

  /** 画布扩展：提示词上限（feed 无该限制） */
  canvas: {
    limits: { promptMaxLength: 8000 },
  },
};
